import { render, staticRenderFns } from "./UserSettingsClasses.vue?vue&type=template&id=75b58476"
import script from "./UserSettingsClasses.vue?vue&type=script&lang=js"
export * from "./UserSettingsClasses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports